import axios from "axios";

const BASE_URL = process.env.VUE_APP_BASE_URL_CORE + "auth/helpGlobal";

export default {
  getAll() {
    return axios({
      method: "get",
      url: BASE_URL,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  create(data) {
    return axios({
      method: "post",
      data: data,
      url: BASE_URL,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  update(id, data) {
    return axios({
      method: "post",
      data: data,
      url: `${BASE_URL}/${id}`,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  delete(id) {
    return axios({
      method: "delete",
      url: `${BASE_URL}/${id}`,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  get(id) {
    return axios({
      method: "get",
      url: `${BASE_URL}/${id}`,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getByUrlRef(data) {
    return axios({
      method: "post",
      url: `${BASE_URL}/urlRef`,
      data: data,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
};
